import React from 'react';
import Payment from 'components/Payment';

import MediaSmUp from 'components/Responsive/MediaSmUp';
import Subscription from './Subscription';
import { Props } from './props';
import ExceptionalStoryTrailerSmUp from 'components/Fate/components/Header/ExceptionalStoryTrailerSmUp';
import ExceptionalStoryTrailerXsDown from 'components/Fate/components/Header/ExceptionalStoryTrailerXsDown';
import MediaXsDown from 'components/Responsive/MediaXsDown';

export default function Header({ onClick, data, concealStoryTrailerOnSmallDevices }: Props) {
  return (
    <div key="content fate-header">
      <h1 className="media__heading heading heading--2">
        Become an Exceptional Friend of the Bazaar
      </h1>
      <p>
        Exceptional friends receive a substantial story every month, double the actions
        {' '}
        (up to 40 at once), more cards to draw in their opportunity deck
        {' '}
        (10 instead of 6) and access to the House of Chimes.
      </p>
      
      <MediaSmUp>
        <ExceptionalStoryTrailerSmUp data={data} />
      </MediaSmUp>
      <MediaXsDown>
        {!concealStoryTrailerOnSmallDevices && (
          <ExceptionalStoryTrailerXsDown data={data} />
        )}
      </MediaXsDown>

      <div className="fate-header__subscription-container">
        <Subscription
          onClick={onClick}
        />
      </div>
      <Payment />
    </div>
  );
}
